import {
    ViewEncapsulation,
    Component,
    HostBinding,
    ElementRef,
    input,
    ChangeDetectionStrategy,
    inject,
    OnInit,
} from '@angular/core';
import { SizeRange } from '@bazis/shared/models/base.types';

const sharedStylesheet = new CSSStyleSheet();
sharedStylesheet.replaceSync(
    `:host { --size: initial; --size-compact: var(--size); --size-large: var(--size); --box-shadow: inherit; --width-state-first: initial; --width-state-secondary: initial; --width-state-first-compact: var(--width-state-first); --width-state-secondary-compact: var(--width-state-secondary); --width-state-first-large: var(--width-state-first); --width-state-secondary-large: var(--width-state-secondary); --animation-duration: 1s; display: block; height: var(--size); width: var(--size); border-radius: 50%; box-shadow: var(--box-shadow); background: var(--bazis-color-white); outline: var(--width-state-first) solid var(--bazis-color-black); animation: pulse var(--animation-duration) infinite; } :host(.bazis-color) { background: var(--bazis-color-base); } @keyframes pulse { 0% { outline-width: var(--width-state-first); } 100% { outline-width: var(--width-state-secondary); } }`,
);

@Component({
    selector: 'bazis-indicator',
    template: ``,
    // styleUrls: ['indicator.component.scss'],
    encapsulation: ViewEncapsulation.ShadowDom,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class IndicatorElement implements OnInit {
    public el = inject(ElementRef);

    readonly size = input<SizeRange>(SizeRange.regular);
    //                 mini  compact    regular    large    huge    giant
    // readonly size = input<'small' | 'medium' | 'large'>('medium');

    @HostBinding('class') get elementStyle() {
        return {
            [`bazis-indicator-${this.size()}`]: !!this.size(),
        };
    }

    ngOnInit(): void {
        const host = this.el.nativeElement;
        if (host && host.shadowRoot) {
            const shadowRoot = host.shadowRoot;
            const styles = shadowRoot.querySelectorAll('style');
            styles.forEach((style) => style.remove());
            shadowRoot.adoptedStyleSheets = [sharedStylesheet];
        }
    }
}
